import { Beneficio, Cultura, Documento, Garantia } from "@/types/produto";
import { createContext, Dispatch, ReactNode, useContext, useReducer } from "react";
import { v4 as uuidv4 } from 'uuid';

type Informacoes = {
    beneficios: Beneficio[],
    culturas: Cultura[],
    garantias: Garantia[],
    documentos: Documento[],
    arquivos: File[],
}


type Props = {
    children: ReactNode;
}

export type ProdutoContextType = {
  informacoes : Informacoes;
  dispatch: Dispatch<any>;
}

const informacaoVazia: Informacoes = {
    beneficios: [],
    culturas: [],
    garantias: [],
    documentos: [],
    arquivos: [],
}

const ProdutoContext = createContext<ProdutoContextType>({
    informacoes: informacaoVazia,
    dispatch: () => null,
});

function reducer(state: Informacoes, action: any){
    switch(action.type){
        case 'ADD_CULTURA':
            action.payload.id = uuidv4();
            return {...state, culturas: [...state.culturas, action.payload]};
        case 'REMOVE_CULTURA':
            return {...state, culturas: state.culturas.filter(cultura => cultura.id !== action.payload.id)};
        case 'UPDATE_CULTURA':
            return {...state, culturas: state.culturas.map(cultura => cultura.id === action.payload.id ? action.payload : cultura)};
        case 'ADD_GARANTIA':
            action.payload.id = uuidv4();
            return {...state, garantias: [...state.garantias, action.payload]};
        case 'REMOVE_GARANTIA':
            return {...state, garantias: state.garantias.filter(garantia => garantia.id !== action.payload.id)};
        case 'UPDATE_GARANTIA':
            return {...state, garantias: state.garantias.map(garantia => garantia.id === action.payload.id ? action.payload : garantia)};
        case 'ADD_BENEFICIO':
            action.payload.id = uuidv4();
            return {...state, beneficios: [...state.beneficios, action.payload]};
        case 'REMOVE_BENEFICIO':
            return {...state, beneficios: state.beneficios.filter(beneficio => beneficio.id !== action.payload.id)};
        case 'UPDATE_BENEFICIO':
            return {...state, beneficios: state.beneficios.map(beneficio => beneficio.id === action.payload.id ? action.payload : beneficio)};
        case 'ADD_DOCUMENTO': {
            const id = uuidv4();
            action.payload.id = id;

            const capaNome = `capa-${id}`;
            const urlNome = `imagem-${id}`;
            
            const capa = new File([action.payload.capa], capaNome, { type: action.payload.capa.type });
            const url = new File([action.payload.url], urlNome, { type: action.payload.url.type });

            action.payload.capa = capaNome;
            action.payload.url = urlNome;

            state.arquivos.push(capa);
            state.arquivos.push(url);
            return {...state, documentos: [...state.documentos, action.payload]};
        }
        case 'REMOVE_DOCUMENTO':
            return {...state, documentos: state.documentos.filter(documento => documento.id !== action.payload.id)};
        case 'UPDATE_DOCUMENTO': {
            const capaNome = `capa-${action.payload.id}`;
            const urlNome = `imagem-${action.payload.id}`;
            
            const capa = new File([action.payload.capa], capaNome, { type: action.payload.capa.type });
            const url = new File([action.payload.url], urlNome, { type: action.payload.url.type });

            action.payload.capa = capaNome;
            action.payload.url = urlNome;

            state.arquivos.push(capa);
            state.arquivos.push(url);
            
            return {...state, documentos: state.documentos.map(documento => documento.id === action.payload.id ? action.payload : documento)};

        }
        case 'SET_INFORMACOES':
            return {...action.payload, arquivos: []};
        default:
            return state;
    }
}

const ProdutoProvider = ({children}: Props) => {
    const [state, dispatch] = useReducer(reducer, informacaoVazia);


    return (
        <ProdutoContext.Provider value={{informacoes: state, dispatch}}>
                {children}
        </ProdutoContext.Provider>
    )
}

export default ProdutoProvider;

//eslint-disable-next-line
export const useProdutoContext = () => useContext(ProdutoContext);